export const getSettings = (state) => state.setting.settings;
export const getSettingsObject = (state) => state.setting.settingsObject;
